import {
  CreateProjectEstimateRequest,
  CreateProjectEstimateResponse,
  GetProjectEstimatesRequest,
  GetProjectEstimatesResponse,
  Estimate,
  UpdateProjectEstimateRequest,
  UpdateProjectEstimateResponse,
  EstimateMasterFormatDivision,
  ListEstimateStatusesResponse,
  ListEstimateStatusesRequest,
  DeleteProjectEstimateRequest,
  DeleteProjectEstimateResponse,
} from './protosCompiled/projectEstimate/projectEstimate_pb';
import { clients } from '../clients/grpcClients';
import { useLocalStorage } from '../stores/localStorage';

export class ProjectEstimateService {
  private static getMetadata() {
    const sessionToken = useLocalStorage.getState().sessionToken;
    if (!sessionToken) {
      console.error('Session token is missing!');
    }
    return {
      sessionToken,
    };
  }

  public static createProjectEstimate = (
    data: Estimate.AsObject
  ): Promise<CreateProjectEstimateResponse> => {
    const masterFormatDivision = new EstimateMasterFormatDivision();
    masterFormatDivision.setId(data.masterformatdivision?.id || '');
    masterFormatDivision.setDivisionnumber(data.masterformatdivision?.divisionnumber || 0);
    masterFormatDivision.setDivisionname(data.masterformatdivision?.divisionname || '');

    const pe = new Estimate();
    pe.setDescription(data.description || '');
    pe.setDuedate(data.duedate || '');
    pe.setProjectid(data.projectid || '');
    pe.setName(data.name || '');
    pe.setCustomid(data.customid || '');
    pe.setMasterformatdivision(masterFormatDivision);
    pe.setEstimatestatusid(data.estimatestatusid || '');

    const req = new CreateProjectEstimateRequest();
    req.setSessiontoken(this.getMetadata().sessionToken || '');
    req.setEstimate(pe);

    return new Promise((resolve, reject) => {
      clients.projectEstimateClient.createProjectEstimate(req, {}, (err: any, response: any) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  };

  public static fetchEstimates = (
    projectId: string
  ): Promise<GetProjectEstimatesResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new GetProjectEstimatesRequest();
      request.setProjectid(projectId);
      request.setSessiontoken(this.getMetadata().sessionToken);
      clients.projectEstimateClient.getProjectEstimates(request, {}, (err: any, response: any) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  };

  public static updateProjectEstimate = (
    data: Estimate.AsObject
  ): Promise<UpdateProjectEstimateResponse.AsObject> => {
    const masterFormatDivision = new EstimateMasterFormatDivision();
    masterFormatDivision.setId(data.masterformatdivision?.id || '');
    masterFormatDivision.setDivisionnumber(data.masterformatdivision?.divisionnumber || 0);
    masterFormatDivision.setDivisionname(data.masterformatdivision?.divisionname || '');

    const estimate = new Estimate();
    estimate.setEstimateid(data.estimateid || '');
    estimate.setDescription(data.description || '');
    estimate.setDuedate(data.duedate || '');
    estimate.setProjectid(data.projectid || '');
    estimate.setName(data.name || '');
    estimate.setCustomid(data.customid || '');
    estimate.setMasterformatdivision(masterFormatDivision);
    estimate.setEstimatestatusid(data.estimatestatusid || '');

    const req = new UpdateProjectEstimateRequest();
    req.setSessiontoken(this.getMetadata().sessionToken || '');
    req.setEstimate(estimate);

    return new Promise((resolve, reject) => {
      clients.projectEstimateClient.updateProjectEstimate(req, {}, (err: any, response: any) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  };

  public static deleteProjectEstimate = (
    estimateId: string
  ): Promise<DeleteProjectEstimateResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new DeleteProjectEstimateRequest();
      request.setEstimateid(estimateId);
      request.setSessiontoken(this.getMetadata().sessionToken || '');
      console.log('deleteProjectEstimate', request.toObject());
      clients.projectEstimateClient.deleteProjectEstimate(
        request,
        {},
        (err: any, response: any) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(response.toObject());
        }
      );
    });
  };

  public static listEstimateStatuses = (): Promise<ListEstimateStatusesResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new ListEstimateStatusesRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);
      clients.projectEstimateClient.listEstimateStatuses(request, {}, (err: any, response: any) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(response.toObject());
      });
    });
  };
}
